import React from 'react';
import List from '../ui/List';

const CourseList = ({ courses }) => {
    const renderCourse = (course) => (
        <li key={course.id} className="py-3 flex justify-between items-center">
            <div className="flex flex-col">
                <span className="font-semibold">{course.name}</span>
                <span className="text-sm text-gray-500">Taught by: {course.teacher}</span>
            </div>
        </li>
    );

    return (
        <div>
            <h3 className="text-lg font-semibold mb-2">Courses</h3>
            <List items={courses} renderItem={renderCourse} />
        </div>
    );
};

export default CourseList;
